import PagingWrapper from './PagingWrapper';
import PagingWrapperContainer from './PagingWrapper.container';

export default PagingWrapperContainer(PagingWrapper);
